import { TOOL_PAGES } from '../content/catalogue.js';
import { Layout } from './Layout.js';

/**
 * 404. Kept useful rather than decorative: someone who mistyped a tool URL is
 * one click from the tool they wanted.
 */
export function NotFound({ path }: { path: string }) {
  return (
    <Layout
      title="Page not found — PrivatePDF"
      description="That page does not exist. Every PrivatePDF tool runs in your browser without uploading your file."
      canonical={path}
    >
      <main className="shell-narrow py-20 sm:py-28">
        <p className="eyebrow">Error 404</p>
        <h1 className="display-sm optical-display mt-3">Page not found</h1>
        <p className="mt-4 leading-relaxed text-muted">
          There is nothing at{' '}
          <code className="rounded-md border border-line bg-surface-2 px-1.5 py-0.5 font-mono-ui text-[0.8125rem] text-ink">
            {path}
          </code>
          .
        </p>

        <p className="eyebrow mt-12">Try one of these</p>
        <ul className="mt-4 flex flex-wrap gap-2">
          {TOOL_PAGES.map((page) => (
            <li key={page.slug}>
              <a href={`/${page.slug}`} className="chip">
                {page.title}
              </a>
            </li>
          ))}
        </ul>
      </main>
    </Layout>
  );
}
